import { render, staticRenderFns } from "./TitleBase.vue?vue&type=template&id=1e54b6b6&scoped=true&lang=pug&"
var script = {}
import style0 from "./TitleBase.vue?vue&type=style&index=0&id=1e54b6b6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e54b6b6",
  null
  
)

export default component.exports